import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FadeUp } from "@/components/site/Reveal";
import api from "@/lib/api";
import { ArrowUpRight } from "lucide-react";

const fmtDate = (iso) =>
  new Date(iso).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });

export const BlogPreview = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/blog").then(({ data }) => setPosts(data.slice(0, 3))).catch(() => {});
  }, []);

  if (posts.length === 0) return null;

  return (
    <section id="journal" data-testid="blog-preview-section" className="bg-muted py-28 md:py-40 border-t border-border">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <FadeUp>
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
            <div>
              <p className="font-mono2 text-xs uppercase tracking-[0.3em] text-primary mb-6">/ Journal</p>
              <h2 className="font-display text-5xl md:text-7xl leading-[0.95]">News & insights</h2>
            </div>
            <Link
              to="/blog"
              data-testid="view-all-posts"
              className="font-mono2 text-xs uppercase tracking-[0.2em] inline-flex items-center gap-2 link-underline self-start md:self-auto"
            >
              View all <ArrowUpRight size={14} />
            </Link>
          </div>
        </FadeUp>

        <div className="grid md:grid-cols-3 gap-8">
          {posts.map((p, i) => (
            <FadeUp key={p.id} delay={i * 0.1}>
              <Link to={`/blog/${p.slug}`} className="group block bg-card border border-border h-full" data-testid={`preview-post-${i}`}>
                <div className="overflow-hidden aspect-[16/10]">
                  <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 font-mono2 text-[11px] uppercase tracking-[0.15em] text-primary mb-4">
                    <span>{p.category}</span>
                    <span className="text-muted-foreground">{fmtDate(p.created_at)}</span>
                  </div>
                  <h3 className="font-display text-2xl leading-tight mb-3">{p.title}</h3>
                  <p className="text-sm text-muted-foreground line-clamp-3">{p.excerpt}</p>
                </div>
              </Link>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
};
